module.exports = __webpack_public_path__ + "img/reat.3b0600ae.png";